import {
  CreateUtilCategoryDto,
  DeleteUtilCategoryDto,
  EditUtilCategoryDto,
  GetUtilCategoryDto,
  MessageResponseDto,
  UtilCategoryControllerGet200Response,
  UtilityCategoryApiFp,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseUtilCategoryModel = UtilCategoryControllerGet200Response;
export type GetUtilCategoryModel = GetUtilCategoryDto;
export type MutateResponseUtilCategoryModel = MessageResponseDto;
export type CreateUtilCategoryModel = CreateUtilCategoryDto;
export type UpdateUtilCategoryModel = EditUtilCategoryDto;
export type DeleteUtilCategoryModel = DeleteUtilCategoryDto;

export const apiUtilCategoryFp = UtilityCategoryApiFp(apiConfig);
export const getUtilCategoryController =
  apiUtilCategoryFp.utilCategoryControllerGet;
export const createUtilCategoryController =
  apiUtilCategoryFp.utilCategoryControllerCreate;
export const updateUtilCategoryController =
  apiUtilCategoryFp.utilCategoryControllerEdit;
export const deleteUtilCategoryController =
  apiUtilCategoryFp.utilCategoryControllerDelete;

export const QueryKeyUtilCategory = QueryKey.UtilCategory;
